import { createApp, createVNode, render } from 'vue'

import '@avriopolis/common/style/index.scss'
import { Spinner } from '@avriopolis/common/components'

import 'simplebar/dist/simplebar.css'

import router from '@/router'
import i18n from '@/i18n'
import App from '@/App.vue'
import { fetchProjects } from '@/store/project'
import Auth from '@/store/auth'

import axios from '@/api'
import Swal from 'sweetalert2'

// Global error handler
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error)
})

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason)
})

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log(error?.request)
    console.log('Error:', error)
    if (error?.response?.status === 403) {
      setTimeout(() => {
        Swal.fire({
          title: `You do not have the authorisation to carry out that action.`,
          icon: 'warning',
          confirmButtonColor: '#0d6efd',
        })
      }, 500)
    }
    return error
  },
)

const node = document.querySelector('#app') || document.body

const loadApp = async () => {
  render(createVNode(Spinner), node)

  try {
    // Try to refresh auth token, but don't fail if it doesn't work (user might not be logged in)
    // Only try refresh if we have a token or refresh_token
    const hasToken = Auth.token.value || localStorage.getItem('token')
    const hasRefreshToken = Auth.refreshToken.value || localStorage.getItem('refresh_token')
    
    if (hasToken || hasRefreshToken) {
      try {
        await Auth.refresh()
      } catch (e) {
        console.log('Auth refresh failed (user may not be logged in):', e)
        // Clear invalid tokens
        if (e?.response?.status === 400 || e?.response?.status === 401) {
          Auth.token.value = null
          Auth.refreshToken.value = null
          localStorage.removeItem('token')
          localStorage.removeItem('refresh_token')
        }
      }
    }

    // Try to fetch projects, but don't fail if it doesn't work
    try {
      await fetchProjects()
    } catch (e) {
      console.log('Failed to fetch projects:', e)
    }
  } catch (e) {
    console.error('Error during app initialization:', e)
  }

  // Always mount the app, even if auth/projects failed
  try {
    const app = createApp(App)
    app.use(router).use(i18n)
    app.mount(node)
    console.log('App mounted successfully')
  } catch (mountError) {
    console.error('Failed to mount app:', mountError)
    // Show error to user
    node.innerHTML = `
      <div style="padding: 2rem; text-align: center;">
        <h1>Failed to load application</h1>
        <p>Please check the console for errors and refresh the page.</p>
        <pre style="text-align: left; background: #f5f5f5; padding: 1rem; margin-top: 1rem; overflow: auto;">${mountError}</pre>
      </div>
    `
  }
}

loadApp()
